export default __webpack_public_path__ + "img/corona-2.fa42bf07.svg";